// src/app/features/my-team/models/my-team.model.ts
export type TeamRole = 'player' | 'coach' | 'manager' | 'owner';

export const TEAM_ROLE_HIERARCHY: readonly TeamRole[] = ['player', 'coach', 'manager', 'owner'];

/** Roles a non-owner manager may grant — everything below 'owner'. */
export const GRANTABLE_TEAM_ROLES: readonly TeamRole[] = TEAM_ROLE_HIERARCHY.filter((r) => r !== 'owner');

/** True when `role` privilege is >= `minimum` in the team hierarchy. Null role = not a member. */
export function roleAtLeast(role: TeamRole | null, minimum: TeamRole): boolean {
  if (!role) return false;
  return TEAM_ROLE_HIERARCHY.indexOf(role) >= TEAM_ROLE_HIERARCHY.indexOf(minimum);
}

/** A team the current user belongs to, with their role. Mirrors backend TeamSchema + my_role. */
export interface MyTeam {
  id: number;
  title: string;
  description: string | null;
  sport_id: number | null;
  isprivate: boolean;
  team_logo_url?: string | null;
  my_role: TeamRole;
  /** True when a coach is marked as a player-connection manager. Owners are always managers. */
  can_manage_players?: boolean;
  /** True when a coach/manager is flagged to manage team videos. Owners always can. */
  can_manage_videos?: boolean;
  /** Position-category ids this user (as a coach) may manage on the team. */
  my_coach_category_ids?: number[];
}

/** A team roster row. Mirrors backend TeamMemberResponse. */
export interface TeamMember {
  id: number;
  user_id: number;
  team_id: number;
  role: TeamRole;
  username: string;
  email: string;
  /** True when a coach is marked a player-connection manager. Optional: backend may omit it. */
  can_manage_players?: boolean;
  /** True when a coach/manager is flagged to manage team videos. Optional: backend may omit it. */
  can_manage_videos?: boolean;
  /** Position-category ids this coach is assigned to manage. */
  coach_category_ids?: number[];
}

export interface TeamMemberCreate {
  user_id: number;
  role: TeamRole;
}
